import { useContext, useEffect, useRef } from 'react'
import styles from './styles.module.css'
import { StudentsContext } from '../../../utils/context'


export default function Hobbies() {
  const { allForms, addMode, studentTabData, updateInitialValues } = useContext(StudentsContext)

  const { values, setFieldValue, setValues } = allForms

  const { hobby: hobbyData } = studentTabData || {}

  const lastSyncedRef = useRef(null)

  useEffect(() => {
    const dataJson = JSON.stringify(hobbyData)
    if (!addMode && hobbyData && lastSyncedRef.current !== dataJson) {
      lastSyncedRef.current = dataJson
      setValues(prev => ({
        ...prev,
        hobby: { ...hobbyData }
      }))
      if (updateInitialValues) {
        updateInitialValues('hobby', hobbyData)
      }
    }
  }, [hobbyData, addMode, setValues, updateInitialValues])

  const handleChange = (e) => {
    setFieldValue('hobby.hobby', e.target.value)
  }

  return (
    <div className={styles.tabWrapper}>
      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Увлечения</h3>
        <div className={styles.inputsRow}>
          <textarea
            className={styles.hobbyTextarea}
            placeholder='Введите увлечения учащегося...'
            value={(values.hobby || {}).hobby || ''}
            onChange={handleChange}
            rows={6}
            style={{ width: '100%', padding: '0.5rem', fontSize: '14px', resize: 'vertical' }}
          />
        </div>
      </div>
    </div>
  )
}
